import { render, staticRenderFns } from "./graph_methanogenic_potential_per_interface_detail.vue?vue&type=template&id=0f1fdf94"
import script from "./graph_methanogenic_potential_per_interface_detail.js?vue&type=script&lang=js&external"
export * from "./graph_methanogenic_potential_per_interface_detail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports